var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {
  createWalletClient,
  hashMessage,
  serializeTransaction,
  hashTypedData
} from "viem";
import * as viemChains from "viem/chains";
import { hexStringToBase64, hexToSignature } from "@getpara/core-sdk";
function createParaAccount(para, walletAddress) {
  let currentWallet;
  if (walletAddress) {
    currentWallet = para.findWalletByAddress(walletAddress, { type: ["EVM"] });
  } else {
    const walletId = para.findWalletId(void 0, { type: ["EVM"] });
    currentWallet = para.wallets[walletId];
  }
  return {
    address: currentWallet.address,
    publicKey: currentWallet.publicKey || "0x",
    source: "custom",
    type: "local",
    signMessage: (_0) => __async(this, [_0], function* ({ message }) {
      const hashedMessage = hashMessage(message);
      const res = yield para.signMessage({ walletId: currentWallet.id, messageBase64: hexStringToBase64(hashedMessage) });
      const signature = res.signature;
      return `0x${signature}`;
    }),
    signTransaction: (transaction, args) => __async(this, null, function* () {
      let { serializer } = args || {};
      if (!serializer) {
        serializer = serializeTransaction;
      }
      const serializedTx = serializer(transaction, {
        r: "0x",
        s: "0x",
        v: BigInt(0)
      });
      const res = yield para.signTransaction({
        walletId: currentWallet.id,
        rlpEncodedTxBase64: hexStringToBase64(serializedTx.substring(2)),
        chainId: `${transaction.chainId}`
      });
      const signature = res.signature;
      const formattedSig = hexToSignature(`0x${signature}`);
      formattedSig.v += BigInt(27);
      return serializer(transaction, formattedSig);
    }),
    signTypedData: (typedDataDefinition) => __async(this, null, function* () {
      const res = yield para.signMessage({
        walletId: currentWallet.id,
        messageBase64: hexStringToBase64(hashTypedData(typedDataDefinition))
      });
      const signature = res.signature;
      return `0x${signature}`;
    })
  };
}
function getViemChain(chainId) {
  const chainIdNum = Number(chainId);
  for (const chain of Object.values(viemChains)) {
    if (chain.id === chainIdNum) {
      return chain;
    }
  }
  throw new Error(`chain with id ${chainId} not found`);
}
function createParaViemClient(para, params, opts) {
  return createWalletClient(__spreadValues({
    account: (opts == null ? void 0 : opts.noAccount) ? void 0 : createParaAccount(para)
  }, params));
}
export {
  createParaAccount,
  createParaViemClient,
  getViemChain
};
